<template>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;Danh sách báo cáo hiện hành
                    </h3>
                    <div class="card-tools">
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col200">Tên báo cáo</th>
                                    <th class="col100">Loại báo cáo</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.id">
                                    <td></td>
                                    <td>
                                        {{ item.tenBaoCao }}
                                    </td>
                                    <td>
                                        {{ item.tenLoaiBaoCao }}
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="exportExcel(item)" title="Xem chi tiết">
                                            <i class="fas fa-download"></i>
                                            
                                        </button>&nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <!-- <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

        </div>
    </section>
</template>
<script>

import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';

export default {
    name: "TheBaoCaoGiaoDuc",
    components: {
    },
    data() {
        return {
            items: [
                { id: 1, 'tenBaoCao': '1. Giáo dục mầm non', 'loaiBaoCaoId': 1, 'tenLoaiBaoCao': 'Báo cáo trường mầm non', 'ACTIONCODE': 31,'excelName': '1_baocao_gdmn' },
                { id: 2, 'tenBaoCao': '2. Giáo dục mầm non chia theo phường xã', 'loaiBaoCaoId': 1, 'tenLoaiBaoCao': 'Báo cáo trường mầm non', 'ACTIONCODE': 32,'excelName': '2_baocao_gdmn_phuongxa' },
                { id: 3, 'tenBaoCao': '3. Trường học, lớp học tiểu học, trung học cơ sở theo phường xã', 'loaiBaoCaoId': 2, 'tenLoaiBaoCao': 'Báo cáo trường quốc gia', 'ACTIONCODE': 33,'excelName': '3_baocao_gd_truonglop_phuongxa' },
                { id: 4, 'tenBaoCao': '4. Phòng học tiểu học, trung học cơ sở theo phường xã', 'loaiBaoCaoId': 2, 'tenLoaiBaoCao': 'Báo cáo trường quốc gia', 'ACTIONCODE': 34,'excelName': '4_baocao_gd_phonghoc_phuongxa' },
                { id: 5, 'tenBaoCao': '5. Giáo viên tiểu học, trung học cơ sở theo phường xã', 'loaiBaoCaoId': 2, 'tenLoaiBaoCao': 'Báo cáo trường quốc gia', 'ACTIONCODE': 35,'excelName': '5_baocao_gd_giaovien_phuongxa' },
                { id: 6, 'tenBaoCao': '6. Học sinh tiểu học, trung học cơ sở theo phường xã', 'loaiBaoCaoId': 2, 'tenLoaiBaoCao': 'Báo cáo trường quốc gia', 'ACTIONCODE': 36,'excelName': '6_baocao_gd_hocsinh_huongxa' },
            ],

            category_LOAIBAOCAO: [
                { id: 1, 'name': 'Báo cáo trường mầm non' },
                { id: 2, 'name': 'Báo cáo trường quốc gia' }
            ]

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('baoCaoGD', ['getCustomBaoCaoGD']),

        async setup() {
            let header = 'Báo cáo giáo dục (Import VSR)'
            this.setupHeader({ header })
        },

        async exportExcel(item) {
            let params = {
                actionCode: item.ACTIONCODE,
                excelName: item.excelName,
            }
            await this.getCustomBaoCaoGD({ params: params }).then(res => {
                if (res) {
console.log("OKE")
                }
            });
        }
    },
    async mounted() {
        await this.setup()
    }
}
</script>
<style></style>